import React, { Component } from 'react'
import { Row, Col, Button, Alert, Card, Form, Popover, OverlayTrigger } from 'react-bootstrap'
import { components } from 'react-select'
import Select from 'react-select';
import SelectDropDown from '../../../../neetjee_guru/components/selectdropdown/SelectDropDown';
import parse from 'html-react-parser';
import SingleOption from '../../learn_practice/start_error_exam/start_error_page/SingleOption';
import '../../learn_practice/start_error_exam/start_error_page/_errorexam.scss';

import gql from "graphql-tag";
import { graphql } from "react-apollo";
import * as Cookies from "es-cookie";
import * as compose from 'lodash.flowright';
import { withRouter } from "react-router-dom";
import { withApollo } from "react-apollo";
const DropdownIndicator = props => {
    return (
        components.DropdownIndicator && (
            <components.DropdownIndicator {...props}>
                <svg height="20" width="20" viewBox="0 0 20 20" aria-hidden="true" focusable="false" className="css-6q0nyr-Svg"><path fill="currentColor" d="M4.516 7.548c0.436-0.446 1.043-0.481 1.576 0l3.908 3.747 3.908-3.747c0.533-0.481 1.141-0.446 1.574 0 0.436 0.445 0.408 1.197 0 1.615-0.406 0.418-4.695 4.502-4.695 4.502-0.217 0.223-0.502 0.335-0.787 0.335s-0.57-0.112-0.789-0.335c0 0-4.287-4.084-4.695-4.502s-0.436-1.17 0-1.615z"></path></svg>
            </components.DropdownIndicator>
        )
    );
};
const ADD_NOTES = gql`
  mutation(
    $params:AddNotes  
    ) {
        addNotes(
        params: $params
     )
  }
`;

const ADD_REPORT = gql`
  mutation(
    $params:AddReport  
    ) {
        addReport(
        params: $params
     )
  }
`;

const FETCH_GLOBALS = gql` 
query($student_user_id: Int) {
    studentGlobals(student_user_id: $student_user_id){
        reports{
            id
            report
        }
        tags{
            id
            tag
            type
        }
        
        
    }
}

`;
class SeriesExamSection extends Component {

              
    handleFullscreen = () => {
        const institutionid = parseInt(Cookies.get("institution_id"));
        if (institutionid === 100) {
            const elem = document.documentElement;
            let fullscreenPromise;
            if (elem.requestFullscreen) {
                fullscreenPromise = elem.requestFullscreen();
            } else if (elem.mozRequestFullScreen) { /* Firefox */
                fullscreenPromise = elem.mozRequestFullScreen();
            } else if (elem.webkitRequestFullscreen) { /* Chrome, Safari & Opera */
                fullscreenPromise = elem.webkitRequestFullscreen();
            } else if (elem.msRequestFullscreen) { /* IE/Edge */
                fullscreenPromise = elem.msRequestFullscreen();
            }
            // Always close modal after attempting fullscreen
            if (fullscreenPromise && typeof fullscreenPromise.then === 'function') {
                fullscreenPromise.finally(() => this.setState({ showFullscreenModal: false }));
            } else {
                this.setState({ showFullscreenModal: false });
            }
        }
    }




    handleKeyDown = (e) => {
        // Prevent exiting fullscreen on Escape
        if ((e.key === 'Escape' || e.keyCode === 27) && (document.fullscreenElement || document.webkitFullscreenElement || document.mozFullScreenElement || document.msFullscreenElement)) {
            e.preventDefault();
            e.stopPropagation();
        }
    }
    componentDidMount() {
        const institutionid = parseInt(Cookies.get("institution_id"));
        if (institutionid === 100) {
            // Attempt to request fullscreen automatically (will be blocked by most browsers unless triggered by user gesture)
            const elem = document.documentElement;
            if (elem.requestFullscreen) {
                elem.requestFullscreen();
            } else if (elem.mozRequestFullScreen) { /* Firefox */
                elem.mozRequestFullScreen();
            } else if (elem.webkitRequestFullscreen) { /* Chrome, Safari & Opera */
                elem.webkitRequestFullscreen();
            } else if (elem.msRequestFullscreen) { /* IE/Edge */
                elem.msRequestFullscreen();
            }

            // Prevent exiting fullscreen with Escape
            window.addEventListener('keydown', this.handleKeyDown, true);

            // Listen for fullscreen change and show modal if exited
            this._fullscreenChangeHandler = () => {
                const isFullscreen = document.fullscreenElement || document.webkitFullscreenElement || document.mozFullScreenElement || document.msFullscreenElement;
                if (!isFullscreen) {
                    this.setState({ showFullscreenModal: true });
                }
            };
            document.addEventListener('fullscreenchange', this._fullscreenChangeHandler);
            document.addEventListener('webkitfullscreenchange', this._fullscreenChangeHandler);
            document.addEventListener('mozfullscreenchange', this._fullscreenChangeHandler);
            document.addEventListener('MSFullscreenChange', this._fullscreenChangeHandler);
        }
    }

    componentWillUnmount() {
        window.removeEventListener('keydown', this.handleKeyDown, true);
        document.removeEventListener('fullscreenchange', this._fullscreenChangeHandler);
        document.removeEventListener('webkitfullscreenchange', this._fullscreenChangeHandler);
        document.removeEventListener('mozfullscreenchange', this._fullscreenChangeHandler);
        document.removeEventListener('MSFullscreenChange', this._fullscreenChangeHandler);
    }
    constructor(props) {
        super(props)
        this.state = {
            innerreloader: "0",
            currentStep: 1,
            submitError1: "",
            submitError2: "",
            ntags: "",
            nnewtag: "",
            ncomments: "",
            formValid2: false,
            formValid1: false,
            reportreson: "",
            reportcomment: "",
            formErrors: {
                ntags: "",
                nnewtag: "",
                ncomments: "",
                reportcomment: "",
                reportreson: ""
            },
            ntagsValid: false,
            nnewtagValid: false,
            ncommentsValid: false,
            reportcommentValid: false,
            reportresonValid: false,
            
        }
        
        this.popoverHide2 = React.createRef();
        this.cancelFun2 = this.cancelFun2.bind(this);

        this.popoverHide = React.createRef();
        this.cancelFun1 = this.cancelFun1.bind(this);

        this.popoverHide3 = React.createRef();
        this.cancelFun3 = this.cancelFun3.bind(this);
    }
    cancelFun2() {
        this.popoverHide2.handleHide();
    }
    cancelFun1() {
        this.popoverHide.handleHide();
    }
    cancelFun3() {
        this.popoverHide3.handleHide();
    }

    idFunction(data) {
        let id = parseInt(data) + 1;
        return id;
    }

    selecthandleInputChange = (ename, evalue) => {
        const name = ename;
        const value = evalue;
        this.setState({ [name]: value }, () => {
            this.validateField(name, value);
        });
    }
    reporthandleFormSubmit = (contype, conid) => {
        //console.log("handleFormSubmit", contype, conid);
        //e.preventDefault();
        if (this.state.formValid1) {
            const params = {
                mobile: Cookies.get("mobile") || "",
                report_id: parseInt(this.state.reportreson),
                comments: this.state.reportcomment,
                content_type: parseInt(contype),
                custom_content_id: parseInt(conid)
            }
            this.addreport(
                params

            ).catch(error => {
                console.log("catch if error");
                console.log(error);
                this.setState({
                    submitError1: error.graphQLErrors.map(x => x.message)
                });
                console.error("ERR =>", error.graphQLErrors.map(x => x.message));
            });
        } else {
            this.setState({ submitError1: "Please fill all the values to proceed" });
        }
    };
    addreport = async (
        params) => {
        await this.props.addreport({
            variables: {
                params
            },
            update: (store, { data }) => {
                if (data.addReport) {
                    this.setState({
                        currentStep: 5,
                        submitError1: "",
                        formValid1: false,
                        reportreson: "",
                        reportcomment: "",
                        formErrors: {
                            reportcomment: "",
                            reportreson: ""
                        },
                        reportcommentValid: false,
                        reportresonValid: false
                    });
                    setTimeout(() => { this.SetpageLoad() }, 1500);
                }
            }
        });
    };
    SetpageLoad = () => {
        this.setState({ currentStep: 1 });
        this.cancelFun1();

    }
    iconhandleInputChange = e => {
        const name = e.target.name;
        const value = e.target.value;
        this.setState({ [name]: value }, () => {
            this.validateField(name, value);
        });
    };
    validateField(fieldName, value) {
        //console.log("fieldName", fieldName, value);
        let fieldValidationErrors = this.state.formErrors;
        let ntagsValid = this.state.ntagsValid;
        let nnewtagValid = this.state.nnewtagValid;
        let ncommentsValid = this.state.ncommentsValid;
        let reportresonValid = this.state.reportresonValid;
        let reportcommentValid = this.state.reportcommentValid;
        switch (fieldName) {
            case "reportreson":
                if (value.length == "") {
                    reportresonValid = false;
                    fieldValidationErrors.reportreson = "Reason Cannot Be Empty";
                } else {
                    reportresonValid = true;
                    fieldValidationErrors.reportreson = "";
                }

                break;

            case "reportcomment":
                if (value.length == "") {
                    reportcommentValid = false;
                    fieldValidationErrors.reportcomment = "Comments Cannot Be Empty";
                } else {
                    reportcommentValid = true;
                    fieldValidationErrors.reportcomment = "";
                }

                break;
            case "ntags":
                if (value.length == "") {
                    ntagsValid = false;
                    fieldValidationErrors.ntags = "Bookmark new tag Cannot Be Empty";
                } else {
                    ntagsValid = true;
                    fieldValidationErrors.ntags = "";
                }

                break;

            case "nnewtag":
                if (value.length == "") {
                    nnewtagValid = false;
                    fieldValidationErrors.nnewtag = "Bookmark new tag Cannot Be Empty";
                } else {
                    nnewtagValid = true;
                    fieldValidationErrors.nnewtag = "";
                }

                break;

            case "ncomments":
                if (value.length == "") {
                    ncommentsValid = false;
                    fieldValidationErrors.ncomments = "note comments Cannot Be Empty";
                } else {
                    ncommentsValid = true;
                    fieldValidationErrors.ncomments = "";
                }

                break;
            default:
                break;
        }
        this.setState(
            {
                formErrors: fieldValidationErrors,
                reportresonValid: reportresonValid,
                reportcommentValid: reportcommentValid,
                ntagsValid: ntagsValid,
                nnewtagValid: nnewtagValid,
                ncommentsValid: ncommentsValid
            },
            this.validateForm
        );
    }
    validateForm() {
        this.setState({
            formValid1: this.state.reportresonValid && this.state.reportcommentValid,
            formValid2: (this.state.ntagsValid || this.state.nnewtagValid) && this.state.ncommentsValid,
        });
        if (this.state.formValid1) {
            this.setState({ submitError1: "" });
        }
        if (this.state.formValid2) {
            this.setState({ submitError2: "" });
        }

    }
    handleMutipleInputChange = (e, name) => {
        //console.log("handleMutipleInputChange", e, name)
        if (name == "ntags") {
            let ntags = Array();
            if (e != null) {
                for (let i = 0; i < e.length; i++) {
                    const tag = e[i];
                    ntags.push(tag.value);
                }
                this.setState({
                    ntags: ntags.toString()
                }, () => {
                    this.validateField(name, "1")
                });
            }
        }
    };


    handleSaveNext = () => {

const { questions, index, nextsubject } = this.props.stateData;

const currentQuestion = questions[index];

if (!currentQuestion || currentQuestion.attempted == null) {

alert("Please answer the question");

return;

}

if (nextsubject != "1") {
this.props.PnextQuestionfunction();
} else {
this.props.SaveFunction();
}

};



    noteshandleFormSubmit = (contype, conid) => {
        //console.log("handleFormSubmit", contype, conid);
        //e.preventDefault();
        if (this.state.formValid2) {
            const params = {
                mobile: Cookies.get("mobile") || "",
                tags: this.state.ntags,
                new_tag: this.state.nnewtag,
                comments: this.state.ncomments,
                content_type: parseInt(contype),
                custom_content_id: parseInt(conid)
            }
            //console.log("noteshandleFormSubmit", params);
            this.addnotes(
                params

            ).catch(error => {
                console.log("catch if error");
                console.log(error);
                this.setState({
                    submitError2: error.graphQLErrors.map(x => x.message)
                });
                console.error("ERR =>", error.graphQLErrors.map(x => x.message));
            });
        } else {
            this.setState({ submitError2: "Please fill all the values to proceed" });
        }
    };
    addnotes = async (
        params) => {
        await this.props.addnotes({
            variables: {
                params
            },
            update: (store, { data }) => {
                //if (data.addNotes) {
                //console.log("globals1", data.addNotes);
                let globals1 = store.readQuery({
                    query: FETCH_GLOBALS,
                    variables: {
                        student_user_id: parseInt(Cookies.get("id"))
                    }
                });
                //console.log("globals1", globals1, data.addNotes);
                if (this.state.nnewtag != "") {
                    let tarray = globals1.studentGlobals.tags;
                    let newobj = {
                        id: data.addNotes.toString(),
                        tag: this.state.nnewtag,
                        type: "notes",
                        __typename: "Tags"
                    }
                    tarray.push(newobj);
                    globals1.studentGlobals.tags = tarray;
                    //console.log("gbeforewrite", globals1);
                }

                try {
                    store.writeQuery({
                        query: FETCH_GLOBALS,
                        variables: {
                            student_user_id: parseInt(Cookies.get("id"))
                        },
                        data: globals1
                    });

                }
                catch (e) {
                    //console.log("Exception", e);
                }
                this.setState({
                    currentStep: 5,
                    submitError2: "",
                    ntags: "",
                    nnewtag: "",
                    ncomments: "",
                    formValid2: "",
                    formErrors: {
                        ntags: "",
                        nnewtag: "",
                        ncomments: ""
                    },
                    ntagsValid: false,
                    nnewtagValid: false,
                    ncommentsValid: false
                });

                setTimeout(() => { this.SetpageLoad2() }, 1500);
                //}
            }
        });
    };
    SetpageLoad2 = () => {
        this.setState({ currentStep: 1 });
        this.cancelFun2();
    }
    minutesTimer = (data) => {
        var date = new Date(data * 1000);
        var hh = date.getUTCHours();
        var mm = date.getUTCMinutes();
        var ss = date.getSeconds();
        if (hh < 10) { hh = "0" + hh; }
        if (mm < 10) { mm = "0" + mm; }
        if (ss < 10) { ss = "0" + ss; }
        var t = hh + ":" + mm + ":" + ss;
        return t;
    }
    reasonFun(data) {
        let sarray = [];
        for (let i = 0; i < data.length; i++) {
            let idata = data[i];
            const obj = {
                value: idata.id,
                label: idata.reason,
            }
            sarray.push(obj);
        }
        return sarray;
    }
    questionDispalyFunc() {
        let question = parse(this.props.questions[this.props.stateData.index].question);
        //console.log("questionDispalyFunc", question);
        let id = this.props.questions[this.props.stateData.index].id;
        //console.log("questionDispalyFuncid", id);
        let qid = "";
        if (question.props.children != undefined) {
            qid = (question.props.children) + "-" + (id);
        }
        return question;
    }
    reasonsFun() {
        let data = this.props.studentGlobals.reports;
        let sarray = [];
        if (data != undefined) {
            for (let i = 0; i < data.length; i++) {
                let idata = data[i];
                const obj = {
                    value: idata.id,
                    label: idata.report,
                }
                sarray.push(obj);
            }
        }
        return sarray;
    }
    notesTags(typ) {
        let data = this.props.studentGlobals.tags;
        let sarray = [];
        //console.log("notesTags", data);
        if (data != undefined) {
            for (let i = 0; i < data.length; i++) {
                let idata = data[i];
                //bookmark
                if (idata.type == "notes") {
                    const obj = {
                        value: idata.id,
                        label: idata.tag,
                    }
                    sarray.push(obj);
                }

            }
        }
        let somvar = "";
        if (typ == "def") {
            somvar = sarray[0];
        }
        else {
            somvar = sarray;
        }
        return somvar;
    }
    bookmarkFun(typ) {
        let data = this.props.studentGlobals.tags;
        let sarray = [];
        //console.log("notesTags", data);
        if (data != undefined) {
            for (let i = 0; i < data.length; i++) {
                let idata = data[i];
                if (idata.type == "bookmark") {
                    const obj = {
                        value: idata.id,
                        label: idata.tag,
                    }
                    sarray.push(obj);
                }

            }
        }
        let somvar = "";
        if (typ == "def") {
            somvar = sarray[0];
        }
        else {
            somvar = sarray;
        }
        return somvar;
    }
    popoverFunction = (custonid) => {
        return (<Popover {...this.props} id="filter-popover" className="custom-popover shadow border-0" style={{ width: '250px' }}>
            <Popover.Content>
                <div className="content-block p-3">
                    <h6>Report</h6>
                    {this.state.currentStep == 5 ? (
                        <Form.Text className="form-text text-danger">
                            Report saved successfully
                        </Form.Text>
                    ) : (

                        <Form.Text className="form-text text-danger">
                            {this.state.submitError1}

                        </Form.Text>

                    )}
                    <Form>
                        <Form.Group controlId="SelectPrinciple">
                            <SelectDropDown
                                name="reportreson"
                                handleChange={this.selecthandleInputChange}
                                options={this.reasonsFun()}
                                placeholderName={'Select Reasons'}
                                dropdownIndicator={{ DropdownIndicator }}
                            />
                        </Form.Group>
                        <Form.Group controlId="CommentsTextarea1">
                            <Form.Control
                                value={this.state.reportcomment}
                                name="reportcomment"
                                onChange={this.iconhandleInputChange}
                                as="textarea"
                                rows="3"
                                placeholder="Some Comments"
                            />
                            <Form.Text className="form-text text-danger">
                                {this.state.formErrors.reportcomment}
                            </Form.Text>
                        </Form.Group>
                    </Form>
                </div>
                <Row className="text-center border-top">
                    <Col xl={6} lg={6} md={6} sm={6} xs={6} className="border-right">
                        <Button onClick={() => this.cancelFun1()} size="sm" variant="link" className="py-2">
                            Cancel
                        </Button>
                    </Col>
                    <Col xl={6} lg={6} md={6} sm={6} xs={6}>
                        <Button onClick={(e) => this.reporthandleFormSubmit("99", custonid)} size="sm" variant="link" className="py-2">
                            Submit
                        </Button>
                    </Col>
                </Row>
            </Popover.Content>
        </Popover>);
    }

    popoverFunction2 = (custonid) => {
        return (<Popover {...this.props} id="filter-popover" className="custom-popover shadow border-0" style={{ width: '250px' }}>
            <Popover.Content>
                <div className="content-block p-3">
                    <h6>Notes</h6>
                    {this.state.currentStep == 5 ? (
                        <Form.Text className="form-text text-danger">
                            Note saved successfully
                        </Form.Text>
                    ) : (

                        <Form.Text className="form-text text-danger">
                            {this.state.submitError2}

                        </Form.Text>

                    )}
                    <Form>
                        <Form.Group controlId="SelectPrinciple">
                            <Select maxMenuHeight={150}
                                //defaultValue={this.notesTags("def")}
                                isMulti
                                name="ntags"
                                options={this.notesTags()}
                                className="basic-multi-select"
                                classNamePrefix="select"
                                onChange={(e) => this.handleMutipleInputChange(e, "ntags")}
                            />

                        </Form.Group>
                        <div className="mb-2 text-center">
                            <span>or</span>
                        </div>
                        <Form.Group controlId="NewTag2">
                            <Form.Control
                                type="text"
                                placeholder="Enter New Tag"
                                name="nnewtag"
                                value={this.state.newtag}
                                onChange={this.iconhandleInputChange}
                                autoComplete="off" />
                        </Form.Group>
                        <Form.Group controlId="CommentsTextarea2">
                            <Form.Control
                                as="textarea"
                                rows="3"
                                placeholder="Some Comments"
                                name="ncomments"
                                value={this.state.ncomments}
                                onChange={this.iconhandleInputChange} />
                            <Form.Text className="form-text text-danger">
                                {this.state.formErrors.ncomments}
                            </Form.Text>
                        </Form.Group>
                    </Form>
                </div>
                <Row className="text-center border-top">
                    <Col xl={6} lg={6} md={6} sm={6} xs={6} className="border-right">
                        <Button onClick={() => this.cancelFun2()} size="sm" variant="link" className="py-2">
                            Cancel
                        </Button>
                    </Col>
                    <Col xl={6} lg={6} md={6} sm={6} xs={6}>
                        <Button
                            onClick={(e) => this.noteshandleFormSubmit("99", custonid)}
                            //onClick={() => this.popoverHide2.handleHide()} 
                            size="sm" variant="link" className="py-2">
                            Submit
                        </Button>
                    </Col>
                </Row>
            </Popover.Content>
        </Popover>);
    }

    popoverFunction3 = (custonid) => {
        return (<Popover {...this.props} id="filter-popover" className="custom-popover shadow border-0" style={{ width: '250px' }}>
            <Popover.Content>
                <div className="content-block p-3">
                    <h6>Bookmarks</h6>
                    {this.props.stateData.currentStep == 5 ? (
                        <Form.Text className="form-text text-danger">
                            Bookmark saved successfully
                        </Form.Text>
                    ) : (

                        <Form.Text className="form-text text-danger">
                            {this.props.stateData.submitError3}

                        </Form.Text>

                    )}
                    <Form>
                        <Form.Group
                            //controlId="SelectBookmark"
                            controlId="SelectPrinciple">
                            <Select maxMenuHeight={150}
                                //defaultValue={this.bookmarkFun("def")}
                                isMulti
                                name="btags"
                                options={this.bookmarkFun()}
                                className="basic-multi-select"
                                classNamePrefix="select"
                                onChange={(e) => this.props.phandleMutipleInputChange(e, "btags")}
                            />
                        </Form.Group>
                        <div className="mb-2 text-center">
                            <span>or</span>
                        </div>
                        <Form.Group controlId="NewTag3">
                            <Form.Control
                                type="text"
                                placeholder="Enter New Tag"
                                name="bnewtag"
                                value={this.props.stateData.bnewtag}
                                onChange={this.props.parenticonhandleInputChange} />
                        </Form.Group>
                    </Form>
                </div>
                <Row className="text-center border-top">
                    <Col xl={6} lg={6} md={6} sm={6} xs={6} className="border-right">
                        <Button onClick={() => this.cancelFun3()} size="sm" variant="link" className="py-2">
                            Cancel
                        </Button>
                    </Col>
                    <Col xl={6} lg={6} md={6} sm={6} xs={6}>
                        <Button
                            //onClick={() => this.popoverHide3.handleHide()} 
                            onClick={(e) => this.props.parentbookhandleFormSubmit("99", custonid)}
                            size="sm" variant="link" className="py-2">
                            Submit
                        </Button>
                    </Col>
                </Row>
            </Popover.Content>
        </Popover>);
    }

    isValidJSON() {
        //console.log("srefsgs12");
        /*let question1 = this.props.stateData.questions[this.props.stateData.index].question.replace(/src="/g, 'src=\\"');
        //console.log("question1", question1);
        let question2 = question1.replace(/" \/>/g, '\\" />');
        //console.log("question2", question2);*/

        let question1 = this.props.stateData.questions[this.props.stateData.index].question.replaceAll("src=\"", "src=\'");
        question1 = question1.replaceAll("\" alt=\"\"", "\' alt=\'\'");
        question1 = question1.replaceAll("\" ", "\' ");
        question1 = question1.replaceAll("=\"", "=\'");


        question1 = question1.replace(/<\/p>\s*<p>/g, "</p><p>");
        question1 = question1.replace(/\s+\"/g, "\"");
        question1 = question1.replace(/\"(\s+)/g, "\"");

        try {
            let question = JSON.parse(question1);
            //console.log("isValidJSONtrue");


            console.log("eeeee", this.props.stateData.questions[this.props.stateData.index].list1type);


            return (

                <ol className="ml-3 p-0" type={
                    this.props.stateData.questions[this.props.stateData.index].list1type == "alphabets" ? ("A")
                        : (this.props.stateData.questions[this.props.stateData.index].list1type == "numbers") ? ("1")
                            : ("I")}

                >
                    {question.map((item) => (
                        <li>{this.parseFun(item.qlist1)}</li>
                    ))}


                </ol>
            );

        } catch (ex) {
            //console.log("isValidJSONfalse");
            return false;
        }
    }



    isValidJSON2(str) {
        //console.log("srefsgs123");
        /* let question1 = this.props.stateData.questions[this.props.stateData.index].question.replace(/src="/g, 'src=\\"');
         let question2 = question1.replace(/" \/>/g, '\\" />');*/
        let question1 = this.props.stateData.questions[this.props.stateData.index].question.replaceAll("src=\"", "src=\'");
        question1 = question1.replaceAll("\" alt=\"\"", "\' alt=\'\'");
        question1 = question1.replaceAll("\" ", "\' ");
        question1 = question1.replaceAll("=\"", "=\'");

        question1 = question1.replace(/<\/p>\s*<p>/g, "</p><p>");
        question1 = question1.replace(/\s+\"/g, "\"");
        question1 = question1.replace(/\"(\s+)/g, "\"");

        try {

            let question = JSON.parse(question1);
            //console.log("isValidJSONtrue");
            return (
                <ol className="ml-3 p-0" type={
                    this.props.stateData.questions[this.props.stateData.index].list2type == "alphabets" ? ("A")
                        : (this.props.stateData.questions[this.props.stateData.index].list2type == "numbers") ? ("1")
                            : ("I")}>

                    {question.map((item) => (
                        <li>{this.parseFun(item.qlist2)}</li>
                    ))}

                </ol>
            );

        } catch (ex) {
            //console.log("isValidJSONfalse");
            return false;
        }
    }


    parseFun(str) {
        if (str != undefined || str != "") {
            try {
                const removeStyle = str.replace(/style="[^"]*"/g, '');
                const convertToParse = parse(removeStyle);
                return convertToParse;
                // return parse(str);
            } catch (ex) {
                return false;
            }
        }
        else {
            return false;
        }

    }
    onScrollgetQuestionById = async (e) => {
        //console.log("onScrollgetQuestionById");
        this.setState({
            innerreloader: "1"
        });
        const result = await this.props.client.query({
            query: gql` 
            query(
                $question_id: Int, 
                $selection_type: Int
                
                ) {
                    getQuestionById(
                    question_id: $question_id,
                    selection_type: $selection_type
                    )
                    {
                        id
                        question
                        option1
                        option2
                        option3
                        option4
                        compquestion
                        list1type
                        list2type
                        mat_question
                        
                        inputquestion
                        
                        
                    
                }
            }
        `,
            variables: {

                question_id: parseInt(this.props.stateData.questions[this.props.stateData.index].id),
                selection_type: parseInt(this.props.stateData.questions[this.props.stateData.index].selection_type)

            },
        })
        // //console.log("senddata",
        //     "question_id:", parseInt(this.props.stateData.questions[this.props.stateData.index].id)
        // );

        //console.log("newstyledata1234", result.data.getQuestionById);
        this.setState({ innerreloader: "0" });
        if (result.data.getQuestionById.length > 0) {
            this.props.parentonScrollgetQuestionById(result.data.getQuestionById);
        }


    }
    getIndexCount = (subjectId) => {
        let indexValue = 0
        if (subjectId == 1) {
            indexValue = 35
        } else if (subjectId == 2) {
            indexValue = 85
        } else if (subjectId == 3) {
            indexValue = 135
        } else {
            indexValue = 185
        }
        return indexValue
    }
    getQuestionSection = (question) => {
        let section = 'A';
        this.props.stateData.questions.map((item, index) => {
            if (item.id === question.id && (index >= this.getIndexCount(item.subject)) && item.subject == question.subject) {
                section = 'B'
            }
        });
        return section;
    }
    render() {
        const isMobile = window.innerWidth < 768;
        // Modal for re-entering fullscreen
        const fullscreenModal = this.state.showFullscreenModal ? (
            <div style={{
                position: 'fixed',
                top: 0,
                left: 0,
                width: '100vw',
                height: '100vh',
                background: 'rgba(0,0,0,0.7)',
                zIndex: 99999,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center'
            }}>
                <div style={{
                    background: '#fff',
                    padding: 32,
                    borderRadius: 8,
                    boxShadow: '0 2px 16px rgba(0,0,0,0.2)',
                    textAlign: 'center',
                    maxWidth: 400
                }}>
                    <h4>Fullscreen Required</h4>
                    <p>The exam requires fullscreen mode. Please click the button below to re-enter fullscreen.</p>
                    <button onClick={this.handleFullscreen} style={{
                        background: '#007bff',
                        color: '#fff',
                        border: 'none',
                        padding: '10px 24px',
                        borderRadius: 4,
                        fontSize: 16,
                        cursor: 'pointer',
                        marginTop: 16
                    }}>Go Fullscreen</button>
                </div>
            </div>
        ) : null;
        if (this.state.showFullscreenModal) {
            return fullscreenModal;
        }
        let disabled = "";
        if (this.props.stateData.questions[this.props.stateData.index].qdisable == true) {
            disabled = "disabled"
        }
        //console.log("SeriesExamSection", this.props.stateData.questions.filter((a) => a.qtype == "8"));
        const lqlength = this.props.stateData.questions.length - 1;
        //Reasons
        const Reasons = [
            { value: 1, label: 'Reasons-1' },
            { value: 2, label: 'Reasons-2' },
            { value: 3, label: 'Reasons-3' }
        ];
        const SectionData = [
            { value: 'NEET 2020', label: 'NEET 2020', color: '#00B8D9', isFixed: true },
            { value: 'JEE 2020', label: 'JEE 2020', color: '#0052CC', isFixed: true },
            { value: 'EAMCET 2020', label: 'EAMCET 2020', color: '#5243AA' },
        ];
        const DropdownIndicator = props => {
            return (
                components.DropdownIndicator && (
                    <components.DropdownIndicator {...props}>
                        <svg height="20" width="20" viewBox="0 0 20 20" aria-hidden="true" focusable="false" className="css-6q0nyr-Svg"><path fill="currentColor" d="M4.516 7.548c0.436-0.446 1.043-0.481 1.576 0l3.908 3.747 3.908-3.747c0.533-0.481 1.141-0.446 1.574 0 0.436 0.445 0.408 1.197 0 1.615-0.406 0.418-4.695 4.502-4.695 4.502-0.217 0.223-0.502 0.335-0.787 0.335s-0.57-0.112-0.789-0.335c0 0-4.287-4.084-4.695-4.502s-0.436-1.17 0-1.615z"></path></svg>
                    </components.DropdownIndicator>
                )
            );
        };
        const popover = (
            <Popover {...this.props} id="filter-popover" className="custom-popover shadow border-0" style={{ width: '250px' }}>
                <Popover.Content>
                    <div className="content-block p-3">
                        <h6>Report</h6>
                        <Form>
                            <Form.Group controlId="SelectPrinciple">
                                <SelectDropDown
                                    name="reason"
                                    options={Reasons}
                                    placeholderName={'Select Reasons'}
                                    dropdownIndicator={{ DropdownIndicator }}
                                    handleChange={this.props.ParentSelecthandleChange}
                                />
                            </Form.Group>
                            <Form.Group controlId="CommentsTextarea1">
                                <Form.Control as="textarea" rows="3" placeholder="Some Comments" />
                            </Form.Group>
                        </Form>
                    </div>
                    <Row className="text-center border-top">
                        <Col xl={6} lg={6} md={6} sm={6} xs={6} className="border-right">
                            <Button onClick={() => this.popoverHide.handleHide()} size="sm" variant="link" className="py-2">
                                Cancel
                            </Button>
                        </Col>
                        <Col xl={6} lg={6} md={6} sm={6} xs={6}>
                            <Button onClick={() => this.popoverHide.handleHide()} size="sm" variant="link" className="py-2">
                                Submit
                            </Button>
                        </Col>
                    </Row>
                </Popover.Content>
            </Popover>
        );
        const popover2 = (
            <Popover {...this.props} id="filter-popover" className="custom-popover shadow border-0" style={{ width: '250px' }}>
                <Popover.Content>
                    <div className="content-block p-3">
                        <h6>Notes</h6>
                        <Form>
                            <Form.Group controlId="SelectPrinciple">
                                <Select maxMenuHeight={150}
                                    defaultValue={[SectionData[0]]}
                                    isMulti
                                    name="colors"
                                    options={SectionData}
                                    className="basic-multi-select"
                                    classNamePrefix="select"
                                />
                            </Form.Group>
                            <div className="mb-2 text-center">
                                <span>or</span>
                            </div>
                            <Form.Group controlId="NewTag2">
                                <Form.Control type="text" placeholder="Enter New Tag" />
                            </Form.Group>
                            <Form.Group controlId="CommentsTextarea2">
                                <Form.Control as="textarea" rows="3" placeholder="Some Comments" />
                            </Form.Group>
                        </Form>
                    </div>
                    <Row className="text-center border-top">
                        <Col xl={6} lg={6} md={6} sm={6} xs={6} className="border-right">
                            <Button onClick={() => this.popoverHide2.handleHide()} size="sm" variant="link" className="py-2">
                                Cancel
                            </Button>
                        </Col>
                        <Col xl={6} lg={6} md={6} sm={6} xs={6}>
                            <Button onClick={() => this.popoverHide2.handleHide()} size="sm" variant="link" className="py-2">
                                Submit
                            </Button>
                        </Col>
                    </Row>
                </Popover.Content>
            </Popover>
        );
        const popover3 = (
            <Popover {...this.props} id="filter-popover" className="custom-popover shadow border-0" style={{ width: '250px' }}>
                <Popover.Content>
                    <div className="content-block p-3">
                        <h6>Bookmarks</h6>
                        <Form>
                            <Form.Group controlId="SelectBookmark">
                                <Select maxMenuHeight={150}
                                    defaultValue={[SectionData[0]]}
                                    isMulti
                                    name="colors"
                                    options={SectionData}
                                    className="basic-multi-select"
                                    classNamePrefix="select"
                                />
                            </Form.Group>
                            <div className="mb-2 text-center">
                                <span>or</span>
                            </div>
                            <Form.Group controlId="NewTag3">
                                <Form.Control type="text" placeholder="Enter New Tag" />
                            </Form.Group>
                        </Form>
                    </div>
                    <Row className="text-center border-top">
                        <Col xl={6} lg={6} md={6} sm={6} xs={6} className="border-right">
                            <Button onClick={() => this.popoverHide3.handleHide()} size="sm" variant="link" className="py-2">
                                Cancel
                            </Button>
                        </Col>
                        <Col xl={6} lg={6} md={6} sm={6} xs={6}>
                            <Button onClick={() => this.popoverHide3.handleHide()} size="sm" variant="link" className="py-2">
                                Submit
                            </Button>
                        </Col>
                    </Row>
                </Popover.Content>
            </Popover>
        );

        //const { isSubmitted } = this.state;
        return (
            <React.Fragment>
                {this.props.stateData.questions != "" ? (<div className={this.props.stateData.defaultFontSize == "A" ? "error_exam_block py-3 font_size_16" : "error_exam_block py-3 font_size_18"}>
                    <Row style={{ display: "flex", justifyContent: "space-around" }}>
                        {/* <Col xl={2} lg={{ span: 2, order: 1 }} md={{ span: 10, order: 1 }} sm={{ span: 9, order: 1 }} xs={{ span: 12, order: 1 }}>
                            <div className="time-spent my-2">
                                {Cookies.get("examid") == "2" ? (
                                    <React.Fragment>
                                        <h6>Section-{this.props.stateData.questions[this.props.stateData.index].qtype == "8" ? ("B") : ("A")}</h6><br />
                                                                            <h6>Section-{ this.getQuestionSection(this.props.stateData.questions[this.props.stateData.index])}</h6>

                                        <span style={{ fontSize: 14 }}>
                                            {this.props.stateData.questions[this.props.stateData.index].qtype == "8" ? ("Question Type-Numerical Questions") : ("")}
                                        </span><br />
                                    </React.Fragment>
                                ) : (
                                    <React.Fragment>
                                        <h6>Section-{this.getQuestionSection(this.props.stateData.questions[this.props.stateData.index])}</h6>
                                        <br />
                                    </React.Fragment>
                                )}

                                <span style={{ fontSize: 14 }}>QID-{this.props.stateData.questions[this.props.stateData.index].id}</span>
                           
                            </div>
                        </Col> */}
                        {this.props.stateData.questions[this.props.stateData.index].qtype == "9" || this.props.stateData.questions[this.props.stateData.index].qtype == "3" ? (
                            <Col xl={{ span: 10, order: 1 }} lg={{ span: 10, order: 1 }} md={{ span: 12, order: 3 }} sm={{ span: 12, order: 3 }} xs={{ span: 12, order: 3 }}>
                                <div className="question_area my-2">
                                    <div className="q_Name">
                                        <span className="q_No">
                                            {this.idFunction(this.props.stateData.index)}
                                        </span>

                                        {this.parseFun(this.props.stateData.questions[this.props.stateData.index].mat_question)}

                                        {this.props.stateData.questions != "" ?
                                            (
                                                <Row>
                                                    <Col xl={6} lg={6} md={6} sm={12} className="my-2">
                                                        <h5 className="list-title"> List I</h5>

                                                        {this.isValidJSON()}
                                                    </Col>
                                                    <Col xl={6} lg={6} md={6} sm={12} className="my-2">
                                                        <h5 className="list-title"> List II</h5>
                                                        {this.isValidJSON2()}
                                                    </Col>
                                                </Row>
                                            )
                                            :
                                            ("")}
                                        <br />
                                        {this.state.innerreloader == "1" || this.props.stateData.reloader == "2" ? (<div className="text-primary">Reloading</div>) : (<div style={{ color: "#ff0000" }}><a><i onClick={(e) => this.onScrollgetQuestionById(e)} className="fa fa-repeat"> <span >Reload</span></i></a>

                                            <small style={{ color: "#2a346c", fontWeight: "bold" }}>&nbsp;&nbsp;&nbsp;*Note: If you are unable to view the question properly,  click on Reload to refresh the Question</small></div>)}
                                        {this.props.stateData.reloader == "1" ? (
                                            <div className="text-success">Question reloaded</div>
                                        ) : ("")}
                                        {disabled == "disabled" ? (<small style={{ color: "#ff0000", fontWeight: "bold" }}>&nbsp;&nbsp;&nbsp;*you can answer only Maximum 10 Questions</small>) : ("")}
                                    </div>
                                    {this.props.stateData.questions[this.props.stateData.index].answer.split(",").filter((a) => a != "").length > 1 ? (
                                        <div className="q_options mt-4">
                                            <SingleOption
                                                question={this.props.stateData.questions != "" ? this.props.stateData.questions[this.props.stateData.index].id : ""}
                                                option="A"
                                                status={this.props.stateData.questions[this.props.stateData.index].attempted != null ? (this.props.stateData.questions[this.props.stateData.index].attempted.split(",").includes('A') ? true : "") : ""}
                                                ParenthandleInputChange={this.props.ParenthandleInputChange2}
                                                optionText={this.props.stateData.questions != "" ? this.parseFun(this.props.stateData.questions[this.props.stateData.index].option1) : ""}
                                                controlId="formBasicCheckboxOne"
                                                disabled={this.props.stateData.questions[this.props.stateData.index].qdisable}
                                                examType="mocktest"
                                            />
                                            <SingleOption
                                                question={this.props.stateData.questions != "" ? this.props.stateData.questions[this.props.stateData.index].id : ""}
                                                option="B"
                                                status={this.props.stateData.questions[this.props.stateData.index].attempted != null ? (this.props.stateData.questions[this.props.stateData.index].attempted.split(",").includes('B') ? true : "") : ""}
                                                ParenthandleInputChange={this.props.ParenthandleInputChange2}
                                                optionText={this.props.stateData.questions != "" ? this.parseFun(this.props.stateData.questions[this.props.stateData.index].option2) : ""}
                                                controlId="formBasicCheckboxTwo"
                                                disabled={this.props.stateData.questions[this.props.stateData.index].qdisable}
                                                examType="mocktest"
                                            />
                                            <SingleOption
                                                question={this.props.stateData.questions != "" ? this.props.stateData.questions[this.props.stateData.index].id : ""}
                                                option="C"
                                                status={this.props.stateData.questions[this.props.stateData.index].attempted != null ? (this.props.stateData.questions[this.props.stateData.index].attempted.split(",").includes('C') ? true : "") : ""}
                                                ParenthandleInputChange={this.props.ParenthandleInputChange2}
                                                optionText={this.props.stateData.questions != "" ? this.parseFun(this.props.stateData.questions[this.props.stateData.index].option3) : ""}
                                                controlId="formBasicCheckboxThree"
                                                disabled={this.props.stateData.questions[this.props.stateData.index].qdisable}
                                                examType="mocktest"
                                            />
                                            <SingleOption
                                                question={this.props.stateData.questions != "" ? this.props.stateData.questions[this.props.stateData.index].id : ""}
                                                option="D"
                                                status={this.props.stateData.questions[this.props.stateData.index].attempted != null ? (this.props.stateData.questions[this.props.stateData.index].attempted.split(",").includes('D') ? true : "") : ""}
                                                ParenthandleInputChange={this.props.ParenthandleInputChange2}
                                                optionText={this.props.stateData.questions != "" ? this.parseFun(this.props.stateData.questions[this.props.stateData.index].option4) : ""}
                                                controlId="formBasicCheckboxFour"
                                                disabled={this.props.stateData.questions[this.props.stateData.index].qdisable}
                                                examType="mocktest"
                                            />
                                        </div>
                                    ) : (
                                        <div className="q_options mt-4">
                                            <SingleOption
                                                question={this.props.stateData.questions != "" ? this.props.stateData.questions[this.props.stateData.index].id : ""}
                                                option="A"
                                                status={this.props.stateData.questions[this.props.stateData.index].attempted === 'A' ? true : null}
                                                ParenthandleInputChange={this.props.ParenthandleInputChange}
                                                optionText={this.props.stateData.questions != "" ? this.parseFun(this.props.stateData.questions[this.props.stateData.index].option1) : ""}
                                                controlId="formBasicCheckboxOne"
                                                disabled={this.props.stateData.questions[this.props.stateData.index].qdisable}
                                                examType="mocktest"
                                            />
                                            <SingleOption
                                                question={this.props.stateData.questions != "" ? this.props.stateData.questions[this.props.stateData.index].id : ""}
                                                option="B"
                                                status={this.props.stateData.questions[this.props.stateData.index].attempted === 'B' ? true : null}
                                                ParenthandleInputChange={this.props.ParenthandleInputChange}
                                                optionText={this.props.stateData.questions != "" ? this.parseFun(this.props.stateData.questions[this.props.stateData.index].option2) : ""}
                                                controlId="formBasicCheckboxTwo"
                                                disabled={this.props.stateData.questions[this.props.stateData.index].qdisable}
                                                examType="mocktest"
                                            />
                                            <SingleOption
                                                question={this.props.stateData.questions != "" ? this.props.stateData.questions[this.props.stateData.index].id : ""}
                                                option="C"
                                                status={this.props.stateData.questions[this.props.stateData.index].attempted === 'C' ? true : null}
                                                ParenthandleInputChange={this.props.ParenthandleInputChange}
                                                optionText={this.props.stateData.questions != "" ? this.parseFun(this.props.stateData.questions[this.props.stateData.index].option3) : ""}
                                                controlId="formBasicCheckboxThree"
                                                disabled={this.props.stateData.questions[this.props.stateData.index].qdisable}
                                                examType="mocktest"
                                            />
                                            <SingleOption
                                                question={this.props.stateData.questions != "" ? this.props.stateData.questions[this.props.stateData.index].id : ""}
                                                option="D"
                                                status={this.props.stateData.questions[this.props.stateData.index].attempted === 'D' ? true : null}
                                                ParenthandleInputChange={this.props.ParenthandleInputChange}
                                                optionText={this.props.stateData.questions != "" ? this.parseFun(this.props.stateData.questions[this.props.stateData.index].option4) : ""}
                                                controlId="formBasicCheckboxFour"
                                                disabled={this.props.stateData.questions[this.props.stateData.index].qdisable}
                                                examType="mocktest"
                                            />
                                        </div>
                                    )}

                                </div>
                            </Col>)
                            : this.props.stateData.questions[this.props.stateData.index].qtype == "8" ?
                                (<Col xl={{ span: 10, order: 1 }} lg={{ span: 10, order: 1 }} md={{ span: 12, order: 3 }} sm={{ span: 12, order: 3 }} xs={{ span: 12, order: 3 }}>
                                    <div className="question_area my-2">
                                        <div className="q_Name">
                                            <span className="q_No">
                                                {this.idFunction(this.props.stateData.index)}
                                            </span>
                                            {this.props.stateData.questions != "" ?
                                                (
                                                    this.parseFun(this.props.stateData.questions[this.props.stateData.index].question)
                                                )
                                                :
                                                ("")}
                                            <br />
                                            {this.state.innerreloader == "1" || this.props.stateData.reloader == "2" ? (<div className="text-primary">Reloading</div>) : (<div style={{ color: "#ff0000" }}><a><i onClick={(e) => this.onScrollgetQuestionById(e)} className="fa fa-repeat"> <span >Reload</span></i></a>

                                                <small style={{ color: "#2a346c", fontWeight: "bold" }}>&nbsp;&nbsp;&nbsp;*Note: If you are unable to view the question properly,  click on Reload to refresh the Question</small></div>)}
                                            {this.props.stateData.reloader == "1" ? (
                                                <div className="text-success">Question reloaded</div>
                                            ) : ("")}
                                            {disabled == "disabled" ? (<small style={{ color: "#ff0000", fontWeight: "bold" }}>&nbsp;&nbsp;&nbsp;*you can only answer 5 integer questions</small>) : ("")}
                                        </div>
                                        {/* integer */}


                                        <Form>
                                            <Form.Group controlId="formBasicEmail">
                                                <Form.Control
                                                    disabled={disabled}
                                                    autoComplete="off"
                                                    onChange={this.props.handleIntegerInputChange}
                                                    type="text"
                                                    placeholder="Enter text"
                                                    name="integer"
                                                    value={this.props.stateData.questions[this.props.stateData.index].attempted != null ? this.props.stateData.questions[this.props.stateData.index].attempted : ""}

                                                />
                                            </Form.Group>
                                        </Form>
                                    </div>
                                </Col>)
                                : this.props.stateData.questions[this.props.stateData.index].qtype == "5" ?
                                    (<Col xl={{ span: 10, order: 1 }} lg={{ span: 10, order: 1 }} md={{ span: 12, order: 3 }} sm={{ span: 12, order: 3 }} xs={{ span: 12, order: 3 }}>
                                        <div className="question_area my-2">
                                            {this.props.stateData.questions[this.props.stateData.index].compquestion != undefined ? (
                                                <Card className="p-3 mb-2 Qparagraph ">
                                                    <Card.Text className="text-justify">{this.parseFun(this.props.stateData.questions[this.props.stateData.index].compquestion)}</Card.Text>
                                                </Card>
                                            ) : ("")}

                                            <div className="q_Name">
                                                <span className="q_No">
                                                    {this.idFunction(this.props.stateData.index)}
                                                </span>
                                                {this.props.stateData.questions != "" ?
                                                    (
                                                        this.parseFun(this.props.stateData.questions[this.props.stateData.index].question)
                                                    )
                                                    :
                                                    ("")}
                                                <br />
                                                {this.state.innerreloader == "1" || this.props.stateData.reloader == "2" ? (<div className="text-primary">Reloading</div>) : (<div style={{ color: "#ff0000" }}><a><i onClick={(e) => this.onScrollgetQuestionById(e)} className="fa fa-repeat"> <span >Reload</span></i></a>

                                                    <small style={{ color: "#2a346c", fontWeight: "bold" }}>&nbsp;&nbsp;&nbsp;*Note: If you are unable to view the question properly,  click on Reload to refresh the Question</small></div>)}
                                                {this.props.stateData.reloader == "1" ? (
                                                    <div className="text-success">Question reloaded</div>
                                                ) : ("")}
                                                {disabled == "disabled" ? (<small style={{ color: "#ff0000", fontWeight: "bold" }}>&nbsp;&nbsp;&nbsp;*you can answer only Maximum 30 Questions</small>) : ("")}
                                            </div>
                                            {this.props.stateData.questions[this.props.stateData.index].answer.split(",").filter((a) => a != "").length > 1 ? (
                                                <div className="q_options mt-4">
                                                    <SingleOption
                                                        question={this.props.stateData.questions != "" ? this.props.stateData.questions[this.props.stateData.index].id : ""}
                                                        option="A"
                                                        status={this.props.stateData.questions[this.props.stateData.index].attempted != null ? (this.props.stateData.questions[this.props.stateData.index].attempted.split(",").includes('A') ? true : "") : ""}
                                                        ParenthandleInputChange={this.props.ParenthandleInputChange2}
                                                        optionText={this.props.stateData.questions != "" ? this.parseFun(this.props.stateData.questions[this.props.stateData.index].option1) : ""}
                                                        controlId="formBasicCheckboxOne"
                                                        disabled={this.props.stateData.questions[this.props.stateData.index].qdisable}
                                                        examType="mocktest"
                                                    />
                                                    <SingleOption
                                                        question={this.props.stateData.questions != "" ? this.props.stateData.questions[this.props.stateData.index].id : ""}
                                                        option="B"
                                                        status={this.props.stateData.questions[this.props.stateData.index].attempted != null ? (this.props.stateData.questions[this.props.stateData.index].attempted.split(",").includes('B') ? true : "") : ""}
                                                        ParenthandleInputChange={this.props.ParenthandleInputChange2}
                                                        optionText={this.props.stateData.questions != "" ? this.parseFun(this.props.stateData.questions[this.props.stateData.index].option2) : ""}
                                                        controlId="formBasicCheckboxTwo"
                                                        disabled={this.props.stateData.questions[this.props.stateData.index].qdisable}
                                                        examType="mocktest"
                                                    />
                                                    <SingleOption
                                                        question={this.props.stateData.questions != "" ? this.props.stateData.questions[this.props.stateData.index].id : ""}
                                                        option="C"
                                                        status={this.props.stateData.questions[this.props.stateData.index].attempted != null ? (this.props.stateData.questions[this.props.stateData.index].attempted.split(",").includes('C') ? true : "") : ""}
                                                        ParenthandleInputChange={this.props.ParenthandleInputChange2}
                                                        optionText={this.props.stateData.questions != "" ? this.parseFun(this.props.stateData.questions[this.props.stateData.index].option3) : ""}
                                                        controlId="formBasicCheckboxThree"
                                                        disabled={this.props.stateData.questions[this.props.stateData.index].qdisable}
                                                        examType="mocktest"
                                                    />
                                                    <SingleOption
                                                        question={this.props.stateData.questions != "" ? this.props.stateData.questions[this.props.stateData.index].id : ""}
                                                        option="D"
                                                        status={this.props.stateData.questions[this.props.stateData.index].attempted != null ? (this.props.stateData.questions[this.props.stateData.index].attempted.split(",").includes('D') ? true : "") : ""}
                                                        ParenthandleInputChange={this.props.ParenthandleInputChange2}
                                                        optionText={this.props.stateData.questions != "" ? this.parseFun(this.props.stateData.questions[this.props.stateData.index].option4) : ""}
                                                        controlId="formBasicCheckboxFour"
                                                        disabled={this.props.stateData.questions[this.props.stateData.index].qdisable}
                                                        examType="mocktest"
                                                    />
                                                </div>
                                            ) : (
                                                <div className="q_options mt-4">
                                                    <SingleOption
                                                        question={this.props.stateData.questions != "" ? this.props.stateData.questions[this.props.stateData.index].id : ""}
                                                        option="A"
                                                        status={this.props.stateData.questions[this.props.stateData.index].attempted === 'A' ? true : null}
                                                        ParenthandleInputChange={this.props.ParenthandleInputChange}
                                                        optionText={this.props.stateData.questions != "" ? this.parseFun(this.props.stateData.questions[this.props.stateData.index].option1) : ""}
                                                        controlId="formBasicCheckboxOne"
                                                        disabled={this.props.stateData.questions[this.props.stateData.index].qdisable}
                                                        examType="mocktest"
                                                    />
                                                    <SingleOption
                                                        question={this.props.stateData.questions != "" ? this.props.stateData.questions[this.props.stateData.index].id : ""}
                                                        option="B"
                                                        status={this.props.stateData.questions[this.props.stateData.index].attempted === 'B' ? true : null}
                                                        ParenthandleInputChange={this.props.ParenthandleInputChange}
                                                        optionText={this.props.stateData.questions != "" ? this.parseFun(this.props.stateData.questions[this.props.stateData.index].option2) : ""}
                                                        controlId="formBasicCheckboxTwo"
                                                        disabled={this.props.stateData.questions[this.props.stateData.index].qdisable}
                                                        examType="mocktest"
                                                    />
                                                    <SingleOption
                                                        question={this.props.stateData.questions != "" ? this.props.stateData.questions[this.props.stateData.index].id : ""}
                                                        option="C"
                                                        status={this.props.stateData.questions[this.props.stateData.index].attempted === 'C' ? true : null}
                                                        ParenthandleInputChange={this.props.ParenthandleInputChange}
                                                        optionText={this.props.stateData.questions != "" ? this.parseFun(this.props.stateData.questions[this.props.stateData.index].option3) : ""}
                                                        controlId="formBasicCheckboxThree"
                                                        disabled={this.props.stateData.questions[this.props.stateData.index].qdisable}
                                                        examType="mocktest"
                                                    />
                                                    <SingleOption
                                                        question={this.props.stateData.questions != "" ? this.props.stateData.questions[this.props.stateData.index].id : ""}
                                                        option="D"
                                                        status={this.props.stateData.questions[this.props.stateData.index].attempted === 'D' ? true : null}
                                                        ParenthandleInputChange={this.props.ParenthandleInputChange}
                                                        optionText={this.props.stateData.questions != "" ? this.parseFun(this.props.stateData.questions[this.props.stateData.index].option4) : ""}
                                                        controlId="formBasicCheckboxFour"
                                                        disabled={this.props.stateData.questions[this.props.stateData.index].qdisable}
                                                        examType="mocktest"
                                                    />
                                                </div>)}
                                        </div>
                                    </Col>)
                                    : (
                                        <Col xl={{ span: 10, order: 1 }} lg={{ span: 10, order: 1 }} md={{ span: 12, order: 3 }} sm={{ span: 12, order: 3 }} xs={{ span: 12, order: 3 }}>
                                            <div className="question_area my-2">
                                                <div className="q_Name">
                                                    <span className="q_No">
                                                        {this.idFunction(this.props.stateData.index)}
                                                    </span>
                                                    {this.props.stateData.questions != "" ?
                                                        (
                                                            this.parseFun(this.props.stateData.questions[this.props.stateData.index].question)
                                                        )
                                                        :
                                                        ("")}
                                                    <br />
                                                    {this.state.innerreloader == "1" || this.props.stateData.reloader == "2" ? (<div className="text-primary">Reloading</div>) : (
                                                        <div style={{ color: this.props.stateData.isOnline ? "#ff0000" : "#ccc" }}>
                                                            {this.props.stateData.isOnline ? (
                                                                <a><i onClick={(e) => this.onScrollgetQuestionById(e)} className="fa fa-repeat" style={{ cursor: 'pointer' }}> <span >Reload</span></i></a>
                                                            ) : (
                                                                <span><i className="fa fa-repeat" style={{ cursor: 'not-allowed' }}> <span >Reload</span></i></span>
                                                            )}

                                                            {this.props.stateData.isOnline ? (
                                                                <small style={{ color: "#2a346c", fontWeight: "bold" }}>&nbsp;&nbsp;&nbsp;*Note: If you are unable to view the question properly, click on Reload to refresh the Question</small>
                                                            ) : (
                                                                <small style={{ color: "#dc3545", fontWeight: "bold" }}>&nbsp;&nbsp;&nbsp;*Reload is disabled while offline</small>
                                                            )}
                                                        </div>
                                                    )}
                                                    {this.props.stateData.reloader == "1" ? (
                                                        <div className="text-success">Question reloaded</div>
                                                    ) : ("")}
                                                    {disabled == "disabled" ? (<small style={{ color: "#ff0000", fontWeight: "bold" }}>&nbsp;&nbsp;&nbsp;*you can answer only Maximum 10 Questions</small>) : ("")}
                                                </div>
                                                {this.props.stateData.questions[this.props.stateData.index].answer.split(",").filter((a) => a != "").length > 1 ? (
                                                    <div className="q_options mt-4">
                                                        <SingleOption
                                                            question={this.props.stateData.questions != "" ? this.props.stateData.questions[this.props.stateData.index].id : ""}
                                                            option="A"
                                                            status={this.props.stateData.questions[this.props.stateData.index].attempted != null ? (this.props.stateData.questions[this.props.stateData.index].attempted.split(",").includes('A') ? true : "") : ""}
                                                            ParenthandleInputChange={this.props.ParenthandleInputChange2}
                                                            optionText={this.props.stateData.questions != "" ? this.parseFun(this.props.stateData.questions[this.props.stateData.index].option1) : ""}
                                                            controlId="formBasicCheckboxOne"
                                                            disabled={this.props.stateData.questions[this.props.stateData.index].qdisable}
                                                            examType="mocktest"
                                                        />
                                                        <SingleOption
                                                            question={this.props.stateData.questions != "" ? this.props.stateData.questions[this.props.stateData.index].id : ""}
                                                            option="B"
                                                            status={this.props.stateData.questions[this.props.stateData.index].attempted != null ? (this.props.stateData.questions[this.props.stateData.index].attempted.split(",").includes('B') ? true : "") : ""}
                                                            ParenthandleInputChange={this.props.ParenthandleInputChange2}
                                                            optionText={this.props.stateData.questions != "" ? this.parseFun(this.props.stateData.questions[this.props.stateData.index].option2) : ""}
                                                            controlId="formBasicCheckboxTwo"
                                                            disabled={this.props.stateData.questions[this.props.stateData.index].qdisable}
                                                            examType="mocktest"
                                                        />
                                                        <SingleOption
                                                            question={this.props.stateData.questions != "" ? this.props.stateData.questions[this.props.stateData.index].id : ""}
                                                            option="C"
                                                            status={this.props.stateData.questions[this.props.stateData.index].attempted != null ? (this.props.stateData.questions[this.props.stateData.index].attempted.split(",").includes('C') ? true : "") : ""}
                                                            ParenthandleInputChange={this.props.ParenthandleInputChange2}
                                                            optionText={this.props.stateData.questions != "" ? this.parseFun(this.props.stateData.questions[this.props.stateData.index].option3) : ""}
                                                            controlId="formBasicCheckboxThree"
                                                            disabled={this.props.stateData.questions[this.props.stateData.index].qdisable}
                                                            examType="mocktest"
                                                        />
                                                        <SingleOption
                                                            question={this.props.stateData.questions != "" ? this.props.stateData.questions[this.props.stateData.index].id : ""}
                                                            option="D"
                                                            status={this.props.stateData.questions[this.props.stateData.index].attempted != null ? (this.props.stateData.questions[this.props.stateData.index].attempted.split(",").includes('D') ? true : "") : ""}
                                                            ParenthandleInputChange={this.props.ParenthandleInputChange2}
                                                            optionText={this.props.stateData.questions != "" ? this.parseFun(this.props.stateData.questions[this.props.stateData.index].option4) : ""}
                                                            controlId="formBasicCheckboxFour"
                                                            disabled={this.props.stateData.questions[this.props.stateData.index].qdisable}
                                                            examType="mocktest"
                                                        />
                                                    </div>
                                                ) : (
                                                    <div className="q_options mt-4">
                                                        <SingleOption
                                                            question={this.props.stateData.questions != "" ? this.props.stateData.questions[this.props.stateData.index].id : ""}
                                                            option="A"
                                                            status={this.props.stateData.questions[this.props.stateData.index].attempted === 'A' ? true : null}
                                                            ParenthandleInputChange={this.props.ParenthandleInputChange}
                                                            optionText={this.props.stateData.questions != "" ? this.parseFun(this.props.stateData.questions[this.props.stateData.index].option1) : ""}
                                                            controlId="formBasicCheckboxOne"
                                                            disabled={this.props.stateData.questions[this.props.stateData.index].qdisable}
                                                            examType="mocktest"
                                                        />
                                                        <SingleOption
                                                            question={this.props.stateData.questions != "" ? this.props.stateData.questions[this.props.stateData.index].id : ""}
                                                            option="B"
                                                            status={this.props.stateData.questions[this.props.stateData.index].attempted === 'B' ? true : null}
                                                            ParenthandleInputChange={this.props.ParenthandleInputChange}
                                                            optionText={this.props.stateData.questions != "" ? this.parseFun(this.props.stateData.questions[this.props.stateData.index].option2) : ""}
                                                            controlId="formBasicCheckboxTwo"
                                                            disabled={this.props.stateData.questions[this.props.stateData.index].qdisable}
                                                            examType="mocktest"
                                                        />
                                                        <SingleOption
                                                            question={this.props.stateData.questions != "" ? this.props.stateData.questions[this.props.stateData.index].id : ""}
                                                            option="C"
                                                            status={this.props.stateData.questions[this.props.stateData.index].attempted === 'C' ? true : null}
                                                            ParenthandleInputChange={this.props.ParenthandleInputChange}
                                                            optionText={this.props.stateData.questions != "" ? this.parseFun(this.props.stateData.questions[this.props.stateData.index].option3) : ""}
                                                            controlId="formBasicCheckboxThree"
                                                            disabled={this.props.stateData.questions[this.props.stateData.index].qdisable}
                                                            examType="mocktest"
                                                        />
                                                        <SingleOption
                                                            question={this.props.stateData.questions != "" ? this.props.stateData.questions[this.props.stateData.index].id : ""}
                                                            option="D"
                                                            status={this.props.stateData.questions[this.props.stateData.index].attempted === 'D' ? true : null}
                                                            ParenthandleInputChange={this.props.ParenthandleInputChange}
                                                            optionText={this.props.stateData.questions != "" ? this.parseFun(this.props.stateData.questions[this.props.stateData.index].option4) : ""}
                                                            controlId="formBasicCheckboxFour"
                                                            disabled={this.props.stateData.questions[this.props.stateData.index].qdisable}
                                                            examType="mocktest"
                                                        />
                                                    </div>)}
                                            </div>
                                        </Col>
                                    )}





                        <Col xl={{ span: 2, order: 3 }} lg={{ span: 2, order: 3 }} md={{ span: 2, order: 2 }} sm={{ span: 3, order: 2 }} xs={{ span: 12, order: 2 }}>



                            <div className="instruction my-2">

                                {
                                    Cookies.get("institution_id") == 24 ? (""
                                    ) : (


                                        <ul className="helpTags list-inline m-1 p-0">
                                            <li className="list-inline-item mx-2">
                                                <OverlayTrigger trigger="click" placement="bottom" overlay={this.popoverFunction(this.props.stateData.questions[this.props.stateData.index].id)} ref={r => (this.popoverHide = r)} rootClose>
                                                    <i className="fal fa-info-circle" title="report" />
                                                </OverlayTrigger>
                                            </li>
                                            <li className="list-inline-item mx-2">
                                                <OverlayTrigger trigger="click" placement="bottom" overlay={this.popoverFunction2(this.props.stateData.questions[this.props.stateData.index].id)} ref={r => (this.popoverHide2 = r)} rootClose>
                                                    <i className="fal fa-notes-medical" title="note" />
                                                </OverlayTrigger>
                                            </li>
                                            {this.props.stateData.questions[this.props.stateData.index].bookmarked == "true" ? (<li className="list-inline-item mx-2">

                                                <i className="fas fa-bookmark text-success" title="bookmark" onClick={(e) => this.props.parentremovebookhandleFormSubmit("99", this.props.stateData.questions[this.props.stateData.index].id)} />

                                            </li>) : (<li className="list-inline-item mx-2">
                                                <OverlayTrigger trigger="click" placement="bottom" overlay={this.popoverFunction3(this.props.stateData.questions[this.props.stateData.index].id)} ref={r => (this.popoverHide3 = r)} rootClose>
                                                    <i className="fal fa-bookmark" title="bookmark" />
                                                </OverlayTrigger>
                                            </li>)}
                                        </ul>
                                    )

                                }


                            </div>
                            <div>     <h6 className="mt-3">Time spent <br />in this question</h6>
                                {this.props.stateData.questions != "" ? (
                                    <i className="fal fa-clock"> <span style={{ fontSize: 18 }} className="countdown-time">{this.minutesTimer(this.props.stateData.questions[this.props.stateData.index].timer)}</span></i>) : ("")}</div>
                        </Col>


                    </Row>


                    {


!this.props.stateData.isSubmitted ? (

<Row className="text-center mt-3">
<Col
xl={{ span: 10, offset: 1 }}
lg={{ span: 10, offset: 1 }}
md={12}
sm={12}
xs={12}
className="paginations-btns"
>

<div
style={{
width: isMobile ? "100%" : "calc(100% - 300px)",
position: "fixed",
left: 0,
bottom: 0,
zIndex: 2,
background: "#fff",
padding: isMobile ? "10px" : "15px"
}}
>

{/* TOP BUTTONS */}
<div
style={{
display: "flex",
justifyContent: "center",
gap: "10px",
flexWrap: isMobile ? "wrap" : "nowrap"
}}
>

{/* Save & Next */}
<Button
style={{
borderRadius: "10px",
backgroundColor: "#28a745",
border: "1px solid #28a745",
color: "#fff",
padding: isMobile ? "7px 20px" : "8px 17px",
fontSize: isMobile ? "14px" : "15px",
minWidth: isMobile ? "90px" : "110px",
flex: isMobile ? "1 1 45%" : "unset"
}}
disabled={this.state.innerreloader !== "0"}
onClick={this.handleSaveNext}
>
Save & Next
</Button>


{/* Clear */}
<Button
style={{
borderRadius: "10px",
backgroundColor: "#f0f0ed",
border: "1px solid #C1C1BF",
color: "#000",
padding: isMobile ? "7px 20px" : "8px 17px",
fontSize: isMobile ? "14px" : "15px",
minWidth: isMobile ? "70px" : "90px",
flex: isMobile ? "1 1 45%" : "unset"
}}
disabled={this.state.innerreloader !== "0"}
onClick={this.props.clearoption}
>
Clear
</Button>


{/* Save & Mark for Review */}
<Button
style={{
borderRadius: "10px",
backgroundColor: "#fc8905",
border: "1px solid #fc8905",
color: "#fff",
padding: isMobile ? "7px 20px" : "8px 17px",
fontSize: isMobile ? "14px" : "15px",
minWidth: isMobile ? "120px" : "150px",
flex: isMobile ? "1 1 45%" : "unset"
}}
onClick={this.props.review}
>
Save & Mark for Review
</Button>


{/* Mark for Review & Next */}
<Button
style={{
borderRadius: "10px",
backgroundColor: "#007bff",
border: "1px solid #007bff",
color: "#fff",
padding: isMobile ? "7px 20px" : "8px 17px",
fontSize: isMobile ? "14px" : "15px",
minWidth: isMobile ? "120px" : "150px",
flex: isMobile ? "1 1 45%" : "unset"
}}
onClick={this.props.review}
>
Mark for Review & Next
</Button>

</div>


{/* BOTTOM BUTTONS */}
<div
style={{
display: "flex",
justifyContent: isMobile ? "space-between" : "space-around",
marginTop: "6px"
}}
>

{/* Back */}
<Button
style={{
borderRadius: "10px",
backgroundColor: "#fff",
border: "1px solid #000",
color: "#000",
padding: isMobile ? "3px 8px" : "8px 17px",
fontSize: isMobile ? "14px" : "15px",
minWidth: "70px"
}}
disabled={this.state.innerreloader !== "0"}
onClick={
this.props.stateData.nextsubject != "1"
? this.props.Pskip
: this.props.Psubjectskip
}
>
Back
</Button>


{/* Next */}
<Button
style={{
borderRadius: "10px",
backgroundColor: "#fff",
border: "1px solid #000",
color: "#000",
padding: isMobile ? "3px 8px" : "8px 17px",
fontSize: isMobile ? "14px" : "15px",
minWidth: "70px"
}}
disabled={this.state.innerreloader !== "0"}
onClick={
this.props.stateData.nextsubject != "1"
? this.props.PnextQuestionfunction
: this.props.SaveFunction
}
>
Next
</Button>

</div>

</div>
</Col>
</Row>

) : ("")
//                         !this.props.stateData.isSubmitted ?
//                             (
//                     <>

             

// <Row className="text-center mt-3">
//   <Col
//     xl={{ span: 10, offset: 1 }}
//     lg={{ span: 10, offset: 1 }}
//     md={12}
//     sm={12}
//     xs={12}
//     className="paginations-btns"
//   >
//     <div
//       style={{
//         width: isMobile ? "100%" : "calc(100% - 300px)",
//         position: "fixed",
//         left: 0,
//         bottom: 0,
//         zIndex: 2,
//         background: "#fff",
//         padding: isMobile ? "10px" : "15px"
//       }}
//     >

//       {/* TOP BUTTONS */}
//       <div
//         style={{
//           display: "flex",
//           justifyContent: "center",
//           gap: "10px",
//           flexWrap: isMobile ? "wrap" : "nowrap"
//         }}
//       >

//         <Button
//           style={{
//             borderRadius: "10px",
//             backgroundColor: "#28a745",
//             border: "1px solid #28a745",
//             color: "#fff",
//             padding: isMobile ? "7px 20px" : "8px 17px",
//             fontSize: isMobile ? "14px" : "15px",
//             minWidth: isMobile ? "90px" : "110px",
//             flex: isMobile ? "1 1 45%" : "unset",
//             display:"flex",
//             justifyContent:"center"
//           }}
//         >
//           Save & Next
//         </Button>

//         <Button
//           style={{
//             borderRadius: "10px",
//             backgroundColor: "#f0f0ed",
//             border: "1px solid #C1C1BF",
//             color: "#000",
//             textAlign:"center",
//             padding: isMobile ? "7px 20px" : "8px 17px",
//             fontSize: isMobile ? "14px" : "15px",
//             minWidth: isMobile ? "70px" : "90px",
//             flex: isMobile ? "1 1 45%" : "unset",
//              display:"flex",
//             justifyContent:"center"
//           }}
//         >
//           Clear
//         </Button>

//         <Button
//           style={{
//             borderRadius: "10px",
//             backgroundColor: "#fc8905",
//             textAlign:"center",
//             border: "1px solid #fc8905",
//             color: "#fff",
//             padding: isMobile ? "7px 20px" : "8px 17px",
//             fontSize: isMobile ? "14px" : "15px",
//             minWidth: isMobile ? "120px" : "150px",
//             flex: isMobile ? "1 1 45%" : "unset"
//           }}
//         >
//           Save & Mark for Review
//         </Button>

//         <Button
//           style={{
//             borderRadius: "10px",
//             backgroundColor: "#007bff",
//             border: "1px solid #007bff",
//             textAlign:"center",
//             color: "#fff",
//             padding: isMobile ? "7px 20px" : "8px 17px",
//             fontSize: isMobile ? "14px" : "15px",
//             minWidth: isMobile ? "120px" : "150px",
//             flex: isMobile ? "1 1 45%" : "unset"
//           }}
//         >
//           Mark for Review & Next
//         </Button>

//       </div>

//       {/* BOTTOM BUTTONS */}
//       <div
//         style={{
//           display: "flex",
//           justifyContent: isMobile ? "space-between" : "space-around",
//           marginTop: "6px"
//         }}
//       >

//         <Button
//           style={{
//             borderRadius: "10px",
//             backgroundColor: "#fff",
//             border: "1px solid #000",
//             color: "#000",
//             padding: isMobile ? "3px 8px" : "8px 17px",
//             fontSize: isMobile ? "14px" : "15px",
//             minWidth: "70px",
//             // flex: isMobile ? "1" : "unset"
//              display:"flex",
//             justifyContent:"center"
//           }}
//         >
//           Back
//         </Button>

//         <Button
//           style={{
//             borderRadius: "10px",
//             backgroundColor: "#fff",
//             border: "1px solid #000",
//             color: "#000",
//             padding: isMobile ? "3px 8px" : "8px 17px",
//             fontSize: isMobile ? "14px" : "15px",
//             minWidth: "70px",
//             // flex: isMobile ? "1" : "unset"
//              display:"flex",
//             justifyContent:"center"
//           }}
//         >
//           Next
//         </Button>

//       </div>

//     </div>
//   </Col>
// </Row>



                       
//                     </>





                    
//                            ) : ("")
                 } 
                </div>) : (
                    <div className="text-center pt-5">
                        <span className="text-danger">No Data Available</span>
                    </div>
                )
                }
            </React.Fragment>

        )
    }
}


export default withRouter(withApollo(
    compose(
        graphql(ADD_REPORT, {
            name: "addreport"
        }),
        graphql(ADD_NOTES, {
            name: "addnotes"
        }))(SeriesExamSection)));

